<template>
    <div :class="!audit_mode && !previous ? 'mb-5 pb-5' : 'gray-600 font-scale-sm'">
        <div :class="previous ? 'p-3 gray-500 rounded border border-color-gray-300 bgray-100':''">
            <b-overlay :show="is_visible_by_pipeline === false" rounded="sm" opacity="0.8" bg-color="#efefef">
                <div v-if="headers">
                    <div v-if="is_final_sub_component !== true" class="mb-1 pb-1 d-flex align-items-center">
                        <b-badge class="f-80" variant="basic">
                            <template v-if="is_edit_page && label">
                                {{ sub_code_label }}. ( {{ sub_code }} )
                            </template>
                            <template v-else>
                                {{ sub_code_label }}.
                            </template>
                        </b-badge>

                        <template v-if="!isFieldEmpty(sub_info) && previous !== true">
                            <b-button
                                :id="`i-${sub_code}`"
                                class="px-1 py-0 f-80 ml-1"
                                variant="teal"
                                size="sm"
                                v-b-toggle="`sub_info-${sub_code}`"
                            >
                                <fa icon="book-open"></fa>
                                {{ $t('작성 도움말') }}
                            </b-button>
                        </template>

                        <b-button v-if="show_previous === true && previous !== true"
                                  :id="`p-${ sub_code }`"
                                  class="ml-1 px-1 py-0 f-80"
                                  v-b-toggle="`previous-${sub_code}`"
                                  variant="red5"
                                  size="sm"
                        >
                            <fa icon="history"></fa>
                            {{ $t('과거답변 보기') }}
                        </b-button>
                    </div>

                    <!-- qe previous component -->
                    <template v-if="print_mode !== true && previous !== true">
                        <b-collapse :id="`previous-${sub_code}`" class="mb-45">
                            <df-previous-sub
                                :id="`df_fileUrl_previous-${sub_code}`"
                                :sub_code="sub_code"
                                :company_id="company_id"
                                :company_name="company_name"
                                :campaign_id="campaign_id"
                                :sub_id="sub_id"
                                :sub_init_id="sub_init_id"
                                @previous-sub-loaded="updatePrevious"
                            />
                        </b-collapse>
                    </template>

                    <div :class="sub_description !== '' ? 'mb-3 pt-1' : 'mb-1'">
                        <div v-if="is_indicate_description" class="mr-1 d-inline f-105">
                            {{ showTranslation(sub_description, sub_description_e, sub_description_c) }}
                        </div>
                        <span v-for="item in tags" :key="item.id">
                            <span v-if="item !== ''" class="ml-2 f-80 gray-500"> {{ item }} </span>
                        </span>
                        <span v-if="sub_priority !== ''">
                            <b-button variant="icon" class="mx-2">{{ sub_priority }}</b-button>
                        </span>
                        <!-- sub_condition -->
                        <!-- <div v-if="is_sub_condition_activated==true" :id="`sub_condition-${sub_code}`" class="my-2 py-2">
                            <b-form-checkbox :disabled="is_locked || is_disabled_by_parent" v-model="sub_condition.value" @change="radioSave()"> {{ sub_condition.text }} </b-form-checkbox>
                        </div> -->
                    </div>

                    <template v-if="!isFieldEmpty(sub_info)">
                        <b-collapse
                            :id="`sub_info-${sub_code}`"
                            :visible="print_mode !== true && audit_mode !== true && previous !== true"
                            class="rounded mb-3 border-0 teal8 bg-teal2 f-95"
                        >
                            <div v-html="showTranslation(sub_info, sub_info_e, sub_info_c)" class="p-3"></div>
                        </b-collapse>
                    </template>
                </div>

                <!-- file_URL2 유형 Sub Component -->
                <div
                    :class="['d-md-flex', 'align-items-start', { 'flex-column': audit_mode }, { 'pt-4': !is_final_sub_component }]"
                >
                    <b-button v-b-modal="`file_URL2-${sub_code}`"
                              :class="['mr-0 mr-md-3 mr-lg-5 f-95', { 'mb-3': audit_mode }]"
                              :size="!audit_mode ? '' : 'sm'"
                              :variant="!audit_mode ? 'dark-border' : ''"
                              :disabled="is_disabled_attached"
                              style="min-width:175px;"
                    >
                        {{ $t(`URL / 파일 첨부하기`) }}
                        <fa icon="cloud-upload-alt" class="ml-1"></fa>
                    </b-button>

                    <template v-if="sub_attached_files && sub_attached_files.length">
                        <div>
                            <h3 class="pt-1 f-100"> {{ $t(`업로드된 파일/URL`) }} </h3>
                            <div class="w-100 border-top border-bottom border-color-gray-400 border-style-dashed">
                                <b-table-simple class="bor-table border-0 d-block-helper w-100 mb-0"
                                                style="overflow-x:auto; width:100%;" hover>
                                    <b-thead>
                                        <b-tr class="bgray-200">
                                            <b-th class="align-middle text-center" style="width:50px;">No.</b-th>
                                            <b-th class="align-middle">{{ $t('첨부 파일명 및 URL') }}</b-th>
                                            <b-th class="align-middle text-right" style="width: 50px" v-if="!previous">
                                                {{ $t('삭제') }}
                                            </b-th>
                                        </b-tr>
                                    </b-thead>
                                    <b-tbody>
                                        <b-tr v-for="(item, index) in sub_attached_files"
                                              :key="`sub-${sub_code}-attachments-${item.type}-${index}`"
                                              class="bgray-100"
                                        >
                                            <b-td class="align-middle text-center" style="width:50px;">
                                                <span class="px-2">{{ index + 1 }}.</span>
                                            </b-td>
                                            <b-td class="align-middle text-break-all">
                                                <template v-if="item.type === 'file'">
                                                    <a :ref="`file_${sub_code}_${index}`" class="cursor px-1"
                                                       :download="item.filename"
                                                       @click.prevent="downloadAttachment(item.id, item.filename)"
                                                    >{{ item.filename }}
                                                    </a>
                                                </template>
                                                <template v-else>
                                                    <a :href="item.filename" target="_blank" class="cursor px-1">
                                                        {{ item.filename }}</a>
                                                </template>
                                            </b-td>
                                            <b-td class="align-middle text-right"
                                                  v-if="!previous"
                                            >
                                                <b-btn class="f-90" size="sm" variant="link"
                                                       @click="unlinkAttachment(item.id, item.filename)" :title="$t('첨부 해제')" :aria-label="$t('첨부 해제')"
                                                       :disabled="saving_files || is_loading_global_disabled"
                                                >
                                                    <BIconXCircle variant="danger"/>
                                                </b-btn>
                                            </b-td>
                                        </b-tr>
                                    </b-tbody>
                                </b-table-simple>
                            </div>
                        </div>
                    </template>
                </div>

                <!-- 예전 답변에 남아 있지만 서버에서 찾을 수 없는 파일 — 답변 값은 그대로 두고 다시 첨부하도록 알린다 -->
                <b-alert v-if="missing_files.length && !previous && !print_mode" show variant="warning" class="f-90 mt-2 mb-0">
                    <fa icon="exclamation-triangle" class="mr-1"></fa>{{ $t('파일을 찾을 수 없습니다. 다시 첨부해 주세요.') }}
                    <ul class="mb-0 mt-1">
                        <li v-for="(name, idx) in missing_files" :key="`missing-${sub_code}-${idx}`" class="text-break-all">{{ name }}</li>
                    </ul>
                </b-alert>

                <b-modal :ref="`file_URL2-${sub_code}`"
                         :id="`file_URL2-${sub_code}`"
                         :title="file_modal_title"
                         :no-close-on-esc="saving_files || is_loading_add_attachment || is_loading_link_attachment"
                         :no-close-on-backdrop="saving_files || is_loading_add_attachment || is_loading_link_attachment"
                         hide-header-close
                         size="xl"
                         footer-class="py-2"
                         centered
                         @hide="confirmDiscardUploads"
                         @hidden="initializeDFFileURL2"
                >
                    <b-container fluid>
                        <template v-if="saving_files || is_loading_add_attachment || is_loading_link_attachment">
                            <b-row>
                                <b-col>
                                    <div class="d-flex align-items-center justify-content-center f-120 py-5">
                                        <span class="mr-3"> {{ $t(`파일을 업로드 중입니다. 잠시만 기다려 주세요...`) }} </span>
                                        <b-spinner style="height: 1.5rem;width: 1.5rem;"></b-spinner>
                                    </div>
                                </b-col>
                            </b-row>
                        </template>
                        <template v-else>
                            <b-row class="mb-3">
                                <b-col cols="12">
                                    <b-card>
                                        <template #header>
                                            <div class="d-flex align-items-end justify-content-between">
                                                <h5 class="mb-0">{{ $t('파일 업로드') }}</h5>

                                                <b-btn variant="primary"
                                                       size="sm"
                                                       @click="uploadAttachmentFile"
                                                       :disabled="!uploading_list.length || saving_files || is_loading_add_attachment || is_loading_link_attachment"
                                                >
                                                    <fa icon="save"></fa>
                                                    {{ $t('저장하기') }}
                                                </b-btn>
                                            </div>
                                        </template>
                                        <b-row>
                                            <b-col cols="12" lg="6">
                                                <div class="mb-2">
                                                    <fa icon="paperclip" class="f-100 mr-2"></fa>
                                                    <span class="f-110">File</span>
                                                </div>
                                                <b-form-file
                                                    v-model="attachment_files"
                                                    @input="addFiletoUploadList"
                                                    :placeholder="form_placeholder"
                                                    :disabled="saving_files || is_loading_add_attachment || is_loading_link_attachment"
                                                    class="text-left"
                                                    multiple
                                                >
                                                </b-form-file>
                                                <small class="d-block mt-1 gray-600">{{ attachment_rule_text }}</small>
                                            </b-col>
                                            <b-col cols="12" lg="6">
                                                <div class="mb-2">
                                                    <fa icon="link" class="f-100 mr-2"></fa>
                                                    <span class="f-110">URL</span>
                                                </div>
                                                <b-input-group>
                                                    <b-form-input v-model="attachment_url"
                                                                  placeholder="https://"
                                                                  @keypress.enter="addURLtoUploadList"
                                                                  :disabled="saving_files"
                                                    />
                                                    <b-input-group-append>
                                                        <b-button variant="light" class="border"
                                                                  @click="addURLtoUploadList"
                                                                  :disabled="!attachment_url || saving_files || is_loading_add_attachment || is_loading_link_attachment"
                                                        >
                                                            <BIconPlus/>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-col>
                                        </b-row>

                                        <template v-if="uploading_list.length">
                                            <b-row class="my-3">
                                                <b-col cols="12">
                                                    <hr>
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col cols="">
                                                    <b-card no-body :header="$t('업로드 선택 파일')" header-class="h6">
                                                        <b-table-simple class="mb-0" hover>
                                                            <b-thead>
                                                                <b-tr>
                                                                    <b-th>No.</b-th>
                                                                    <b-th>{{ $t('유형') }}</b-th>
                                                                    <b-th>{{ $t('첨부 파일명 및 URL') }}</b-th>
                                                                    <b-th>{{ $t('삭제') }}</b-th>
                                                                </b-tr>
                                                            </b-thead>
                                                            <b-tbody>
                                                                <b-tr
                                                                    v-for="(upload_item, upload_idx) in uploading_list"
                                                                    :key="`subs-${sub_code}-attachment-uploads-${upload_idx}-type-${upload_item.type}`"
                                                                >
                                                                    <b-td>
                                                                        {{ upload_idx + 1 }}
                                                                    </b-td>
                                                                    <b-td>
                                                                        <b-badge>{{
                                                                                upload_item.type.toLocaleUpperCase()
                                                                            }}
                                                                        </b-badge>
                                                                    </b-td>
                                                                    <b-td>
                                                                        {{ upload_item.name }}
                                                                    </b-td>
                                                                    <b-td>
                                                                        <template v-if="upload_item.type === 'file'">
                                                                            <b-btn variant="danger" size="sm"
                                                                                   @click="deleteFiletoUploadList(upload_item)"
                                                                            >
                                                                                {{ $t('삭제하기') }}
                                                                            </b-btn>
                                                                        </template>
                                                                        <template v-else>
                                                                            <b-btn variant="danger" size="sm"
                                                                                   @click="deleteURLtoUploadList(upload_item)"
                                                                            >
                                                                                {{ $t('삭제하기') }}
                                                                            </b-btn>
                                                                        </template>
                                                                    </b-td>
                                                                </b-tr>
                                                            </b-tbody>
                                                        </b-table-simple>
                                                    </b-card>
                                                </b-col>
                                            </b-row>
                                        </template>
                                    </b-card>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col cols="12">
                                    <b-card :header="$t('문서보관함 첨부내역')" header-class="h5" no-body>
                                        <b-table :items="get_attatchments" :fields="attachments_field"
                                                 :busy="is_loading_attachments_list || is_loading_link_attachment"
                                                 :empty-text="$t('업로드된 파일이 없습니다.')"
                                                 show-empty
                                                 class="mb-0"
                                        >
                                            <template #empty="scope">
                                                <div class="text-center">
                                                    <h6 class="gray-500 mb-0">{{ scope.emptyText }}</h6>
                                                </div>
                                            </template>

                                            <template #table-busy>
                                                <div class="text-center text-danger my-2">
                                                    <strong class="mr-2">{{ $t('처리중입니다. 잠시만 기다려주세요...') }}</strong>
                                                    <b-spinner class="align-middle"
                                                               style="width: 1.3rem;height: 1.3rem;"></b-spinner>
                                                </div>
                                            </template>


                                            <template #cell(index)="data">
                                                <div class="text-center">
                                                    {{ data.index + 1 }}.
                                                </div>
                                            </template>

                                            <template #cell(attachment_type)="data">
                                                <b-badge>{{ data.value.toLocaleUpperCase() }}</b-badge>
                                            </template>

                                            <template #cell(user)="data">
                                                {{ data.value ? data.value.user_name : ' - ' }}
                                            </template>

                                            <template #cell(created_at)="data">
                                                {{ formatDate(data.value) }}
                                            </template>

                                            <template #cell(action)="data">
                                                <template
                                                    v-if="sub_attached_files_id.length && sub_attached_files_id.includes(data.item.id)">
                                                    <b-btn size="sm" variant="danger"
                                                           @click="unlinkAttachment(data.item.id, data.item.filename)"
                                                           :disabled="saving_files || is_loading_global_disabled"
                                                    >
                                                        {{ $t('첨부 해제') }}
                                                    </b-btn>
                                                </template>
                                                <template v-else>
                                                    <b-btn size="sm" variant="primary"
                                                           @click="linkAttachment(data.item.id)"
                                                           :disabled="is_loading_global_disabled"
                                                    >
                                                        {{ $t('첨부하기') }}
                                                    </b-btn>
                                                </template>
                                            </template>
                                        </b-table>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </template>
                    </b-container>

                    <template #modal-footer>
                        <div class="d-flex align-items-center justify-content-end px-3">
                            <b-button variant="secondary"
                                      @click="handleOK(`file_URL2-${sub_code}`)"
                                      :disabled="saving_files || is_loading_global_disabled"
                            >
                                {{ $t(`닫기`) }}
                            </b-button>
                        </div>
                    </template>
                </b-modal>

                <!-- is_visible_by_pipeline 조건에 따른 해당없음 overlay -->
                <template v-slot:overlay>
                    <DFPipelineOverlay :prev_sub_info="prev_sub_info"
                                       :pipeline_title="pipeline_title"
                    />
                </template>
            </b-overlay>
        </div>

        <!-- previous component -->
        <b-collapse v-if="print_mode !== true" :id="previous_sub.sub_code">
            <sub-component v-if="typeof previous_sub.sub_code !== 'undefined' && previous != true"
                           :item="previous_sub"
                           :is_disabled_by_parent="true"
                           :sub_type="previous_sub.sub_type"
                           :previous="true"
                           :disabled="true"
            >
            </sub-component>
        </b-collapse>
    </div>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex'
import * as SentryBrowser from "@sentry/browser";
import {SubComponentMixin} from '@core_mixins/SubComponentMixin'
import downloadFile from '@core_mixins/downloadFile';
import DFPreviousSub from '@core_components/client/components/subs/previous_sub/DFPreviousSub'
import DFPipelineOverlay from "@core_components/client/components/subs/elements/DFPipelineOverlay";
import {isValidURL, pickUploadableFiles, ALLOWED_EXTENSIONS, MAX_FILE_SIZE_MB, MAX_FILES_COUNT} from "@core/utils/subComponent/check-attachment";

export default {
    name: 'df-file-url2',
    mixins: [
        SubComponentMixin,
        downloadFile
    ],
    components: {
        'df-previous-sub': DFPreviousSub,
        DFPipelineOverlay
    },
    data() {
        return {
            saving_files: false,
            is_confirming_unlink: false,
            attachment_files: [],
            attachment_url: 'https://',
            uploading_file: [],
            uploading_urls: [],
            show_previous: false,
        }
    },
    computed: {
        ...mapState(['view_mode', 'campaign_in_progress']),
        ...mapState('questions', ['answer_company']),
        ...mapState('attachments', ['is_loading_attachments_list', 'is_loading_add_attachment', 'is_loading_link_attachment']),
        ...mapGetters('attachments', ['is_loading_global_disabled']),
        attachments_field() {
            return [
                {
                    key: 'index',
                    label: 'No.',
                    thStyle: {
                        'width': '5%'
                    },
                    tdClass: ['f-95']
                },
                {
                    key: 'attachment_type',
                    label: this.$t('첨부 유형'),
                    thStyle: {
                        'width': this.$i18n.locale === 'ko' ? '10%' : '15%'
                    },
                    tdClass: ['f-90']
                },
                {
                    key: 'filename',
                    label: this.$t('파일 이름'),
                    thStyle: {},
                    tdClass: ['f-90 text-break-all']
                },
                {
                    key: 'user',
                    label: this.$t('업로드 사용자'),
                    thStyle: {
                        'width': '10.5%',
                        'text-align': 'center'
                    },
                    tdClass: ['f-90', 'text-center']
                },
                {
                    key: 'action',
                    label: this.$t('설정 및 삭제'),
                    thStyle: {
                        'width': '18%',
                        'text-align': 'center'
                    },
                    tdClass: ['f-90', 'text-center']
                }
            ]
        },
        target_campaign_id() {
            if (this.previous) {
                return this.campaign_in_progress.previous_campaign_id
            }

            return this.$route.query.cmp
        },
        uploading_list() {
            const _uploading_list = []
            if (this.uploading_file.length) {
                this.uploading_file.forEach(file => {
                    _uploading_list.push({type: 'file', name: file.name, file})
                });
            }

            if (this.uploading_urls.length) {
                this.uploading_urls.forEach(url => {
                    _uploading_list.push({type: 'url', name: url, url})
                });
            }

            return _uploading_list
        },
        get_attatchments() {
            if (!this.$store.getters['attachments/get_attatchments'].length) {
                return []
            } else {
                return [...this.$store.getters['attachments/get_attatchments']].sort((a, b) => {
                    if (!a.sub_list && !b.sub_list) {
                        return new Date(b.created_at) - new Date(a.created_at)
                    } else {
                        const _a_inlcuded_sub = a.sub_list.some(({id}) => id === this.sub_id) ? 1 : 0
                        const _b_inlcuded_sub = b.sub_list.some(({id}) => id === this.sub_id) ? 1 : 0

                        if (_a_inlcuded_sub !== _b_inlcuded_sub) {
                            return _b_inlcuded_sub - _a_inlcuded_sub
                        } else {
                            return b.id - a.id
                        }
                    }
                })
            }
        },
        sub_attached_files() {
            return this.get_attatchments.reduce((_sub_attached, _attached) => {
                if (_attached.sub_list) {
                    const _is_attached_to_sub = _attached.sub_list.find(({id}) => id === this.sub_id)
                    if (_is_attached_to_sub) {
                        const {id, attachment_type, filename} = _attached
                        _sub_attached.push({
                            id, type: attachment_type, filename, file_link: null
                        })
                    }
                }

                return _sub_attached
            }, [])
        },
        sub_attached_files_id() {
            if (!this.sub_id || !this.get_attatchments || !this.get_attatchments.length) {
                return []
            }

            return this.get_attatchments.reduce((_sub_attached, _attached) => {
                const _is_attached_to_sub = _attached.sub_list.find(({id}) => id === this.sub_id)
                if (_is_attached_to_sub) {
                    _sub_attached.push(_attached.id)
                }
                return _sub_attached
            }, [])
        },
        file_modal_title() {
            return this.$t(`URL / 파일 첨부하기`)
        },
        form_placeholder() {
            return this.$t(`여기로 끌어오거나, 클릭하여 파일을 찾으세요.`)
        },
        attachment_rule_text() {
            return this.$t('첨부 가능 형식 안내', {extensions: ALLOWED_EXTENSIONS.join(', '), size: MAX_FILE_SIZE_MB, count: MAX_FILES_COUNT})
        },
    },
    watch: {},
    mounted() {
    },
    beforeDestroy() {
        this.saving_files = false
        this.attachment_files = []
        this.attachment_url = 'https://'
        this.uploading_file = []
        this.uploading_urls = []

        this.show_previous = false
    },
    methods: {
        ...mapActions('attachments', ['getAttatchments', 'uploadAttachments', 'linkAttachments', 'unlinkAttachments', 'deleteAttachments']),
        async linkAttachment(storage_id) {
            try {
                let _sub_id = null
                this.saving_files = true

                if (!this.sub_id) {
                    const response = await this.$axios.post('/subs', {
                        sub_id: this.sub_id,
                        sub_init_id: this.sub_init_id,
                        company_id: this.$route.query.cpn,
                        company_name: this.save_company_name,
                        campaign_id: this.$route.query.cmp,
                        question_code: this.question_code,
                        sub_code: this.sub_code,
                        sub_data_contents: this.sub_data_contents,
                        score_result: this.score_result
                    })

                    this.$store.commit('questions/update_sub', response.data)
                    _sub_id = response.data.sub_id
                } else {
                    _sub_id = this.sub_id
                }

                await this.linkAttachments({
                    company_id: this.$route.query.cpn,
                    campaign_id: this.$route.query.cmp,
                    sub_id: _sub_id,
                    sub_code: this.sub_code,
                    storage_id: [storage_id]
                })

                this.uploading_file = []
                this.uploading_urls = []
            } catch (error) {
                SentryBrowser.getCurrentScope().setTransactionName("AttachedFileError");
                SentryBrowser.withScope((scope) => {
                    scope.setTag('company_id', this.$route.query.cpn);
                    scope.setTag('campaign_id', this.$route.query.cmp);
                    scope.setTag('question_code', this.question_code);
                    scope.setTag('sub_id', this.sub_id);
                    scope.setTag('sub_code', this.sub_code);
                    scope.setTag('attached_type', 'link');
                    scope.setLevel("warning");
                    SentryBrowser.captureException(error);
                });

                if (error?.response?.status === 401) return // 인터셉터가 로그인으로 보낸다
                this.$EventBus.$emit('toast-failure', this.$t('알림'), this.$t("죄송합니다. 첨부하는 도중 장애가 발생했습니다. 다시 시도해주세요."))
                await this.refreshAttachments()
            } finally {
                this.saving_files = false
            }
        },
        async unlinkAttachment(attchmt_id, filename) {
            if (this.is_confirming_unlink) return
            this.is_confirming_unlink = true
            let confirmed = false
            try {
                confirmed = await this.$showModal({
                    type: 'confirm',
                    state: 'warning',
                    title: this.$t('첨부 해제'),
                    message: this.$t('첨부 해제 확인 안내', {filename: filename})
                })
            } finally {
                this.is_confirming_unlink = false
            }
            if (!confirmed) return
            try {
                this.saving_files = true
                await this.unlinkAttachments({
                    campaign_id: this.$route.query.cmp,
                    company_id: this.$route.query.cpn,
                    sub_id: this.sub_id,
                    sub_code: this.sub_code,
                    storage_id: [attchmt_id],
                })
            } catch (error) {
                SentryBrowser.getCurrentScope().setTransactionName("AttachedFileError");
                SentryBrowser.withScope((scope) => {
                    scope.setTag('company_id', this.$route.query.cpn);
                    scope.setTag('campaign_id', this.$route.query.cmp);
                    scope.setTag('question_code', this.question_code);
                    scope.setTag('sub_id', this.sub_id);
                    scope.setTag('sub_code', this.sub_code);
                    scope.setTag('attached_type', 'unlink');
                    scope.setLevel("warning");
                    SentryBrowser.captureException(error);
                });

                if (error?.response?.status === 401) return // 인터셉터가 로그인으로 보낸다
                this.$EventBus.$emit('toast-failure', this.$t('첨부 해제'), this.$t('죄송합니다. 첨부 해제 중 장애가 발생했습니다. 다시 시도해주세요.'))
                await this.refreshAttachments()
            } finally {
                this.saving_files = false
            }
        },
        async uploadAttachmentFile() {
            try {
                this.saving_files = true
                if (this.uploading_list.length) {
                    const _res_uploaded = await this.uploadAttachments({
                        company_id: this.$route.query.cpn,
                        campaign_id: this.$route.query.cmp,
                        uploadAttchmts: this.uploading_list
                    })

                    const _uploaded_storage_id = _res_uploaded.map(({id}) => id)

                    if (!this.sub_id) {
                        const response = await this.$axios.post('/subs', {
                            sub_id: this.sub_id,
                            sub_init_id: this.sub_init_id,
                            company_id: this.$route.query.cpn,
                            company_name: this.save_company_name,
                            campaign_id: this.$route.query.cmp,
                            question_code: this.question_code,
                            sub_code: this.sub_code,
                            sub_data_contents: this.sub_data_contents,
                            score_result: this.score_result
                        })

                        this.$store.commit('questions/update_sub', response.data)
                    }

                    await this.linkAttachments({
                        company_id: this.$route.query.cpn,
                        campaign_id: this.$route.query.cmp,
                        sub_id: this.sub_id,
                        sub_code: this.sub_code,
                        storage_id: _uploaded_storage_id
                    })
                }
            } catch (error) {
                SentryBrowser.getCurrentScope().setTransactionName("AttachedFileError");
                SentryBrowser.withScope((scope) => {
                    scope.setTag('company_id', this.$route.query.cpn);
                    scope.setTag('campaign_id', this.$route.query.cmp);
                    scope.setTag('question_code', this.question_code);
                    scope.setTag('sub_id', this.sub_id);
                    scope.setTag('sub_code', this.sub_code);
                    scope.setTag('attached_type', 'upload');
                    scope.setLevel("warning");
                    SentryBrowser.captureException(error);
                });

                if (error?.response?.status === 401) return // 인터셉터가 로그인으로 보낸다
                this.$EventBus.$emit('toast-failure', this.$t('알림'), this.$t("죄송합니다. 파일 업로드 및 문항 첨부 중 장애가 발생했습니다. 다시 시도해주세요."))
                this.attachment_files = []
                this.attachment_url = 'https://'
                this.uploading_file = []
                this.uploading_urls = []

                await this.refreshAttachments()
            } finally {
                this.saving_files = false
            }
        },
        addFiletoUploadList() {
            this.uploading_file = this.uploading_file.concat(pickUploadableFiles(this, this.attachment_files, this.uploading_file))
            this.attachment_files = []
        },
        deleteFiletoUploadList(_file) {
            if (this.uploading_file.length) {
                const _delete_file_idx = this.uploading_file.findIndex(file => file.name === _file.name)
                if (_delete_file_idx > -1) {
                    this.uploading_file.splice(_delete_file_idx, 1)
                }
            }
        },
        addURLtoUploadList() {
            if (!this.attachment_url) {
                return false
            }

            const _is_included_url = this.uploading_urls.find((url) => url === this.attachment_url)
            if (_is_included_url) {
                this.$EventBus.$emit('toast-warning', this.$t('알림'), this.$t('이미 첨부된 주소 입니다.'))
                return false;
            }

            if (!isValidURL(this.attachment_url)) {
                this.$EventBus.$emit('toast-warning', this.$t('알림'), this.$t('올바른 URL 형식으로 입력해 주십시오 (http/https)'))
                return false;
            }

            this.uploading_urls.push(this.attachment_url)
        },
        deleteURLtoUploadList(_url) {
            if (this.uploading_urls.length) {
                const _delete_url_idx = this.uploading_urls.findIndex(url => url === _url.url)
                if (_delete_url_idx > -1) {
                    this.uploading_urls.splice(_delete_url_idx, 1)
                }
            }
        },
        async downloadAttachment(storage_id, filename) {
            try {
                const _res_downdload_attachment = await this.$axios.get('/attachment/download', {
                    params: {storage_id: [storage_id]},
                    responseType: 'blob'
                })

                this.downloadFileFromResponse(_res_downdload_attachment, filename)
            } catch (error) {
                SentryBrowser.getCurrentScope().setTransactionName("AttachedFileError");
                SentryBrowser.withScope((scope) => {
                    scope.setTag('company_id', this.$route.query.cpn);
                    scope.setTag('campaign_id', this.$route.query.cmp);
                    scope.setTag('question_code', this.question_code);
                    scope.setTag('sub_id', this.sub_id);
                    scope.setTag('sub_code', this.sub_code);
                    scope.setTag('attached_type', 'download');
                    scope.setLevel("warning");
                    SentryBrowser.captureException(error);
                });

                if (error?.response?.status === 401) return // 인터셉터가 로그인으로 보낸다
                this.$EventBus.$emit('toast-failure', this.$t('알림'), this.$t("파일 다운로드에 실패하였습니다. 다시 시도해 주세요."))
            }
        },
        // 고른 파일/URL 을 올리지 않고 닫으려 하면 한 번 묻는다 (확인하면 선택을 비우고 닫는다)
        async confirmDiscardUploads(bvEvent) {
            if (this.saving_files || !this.uploading_list.length) return
            bvEvent.preventDefault()
            const confirmed = await this.$showModal({
                type: 'confirm',
                state: 'warning',
                title: this.$t('알림'),
                message: this.$t('업로드하지 않은 파일/URL 안내', {count: this.uploading_list.length})
            })
            if (!confirmed) return
            this.uploading_file = []
            this.uploading_urls = []
            this.$refs[`file_URL2-${this.sub_code}`].hide()
        },
        async refreshAttachments() {
            try {
                await this.getAttatchments({company_id: this.$route.query.cpn, campaign_id: this.$route.query.cmp})
            } catch (error) {
                // 조회 실패는 목록을 그대로 둔다 (401 은 인터셉터가 로그인으로 보낸다)
            }
        },
        initializeDFFileURL2() {
            this.saving_files = false
            this.attachment_files = []
            this.attachment_url = 'https://'
            this.uploading_file = []
            this.uploading_urls = []
        },
        updatePrevious(flag) {
            this.show_previous = flag
        },
        handleOK(ref) {
            this.$refs[ref].hide()
            this.saving_files = false
        },
    }
}
</script>
